/* ==========================================================================
   B2B LABS — comportamiento v2
   Sin dependencias. Idempotente: soporta el editor de temas de Shopify.
   ========================================================================== */
(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  var isReduced = function () { return reduced.matches; };
  var clamp01 = function (v) { return v < 0 ? 0 : v > 1 ? 1 : v; };

  /* ------------------------------------------------------- entrada al viewport */
  var riseObserver = null;
  function initRise(root) {
    var nodes = root.querySelectorAll('.b2b-rise:not([data-b2b-seen])');
    if (!nodes.length) return;

    if (isReduced() || !('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(nodes, function (n) {
        n.setAttribute('data-b2b-seen', '');
        n.classList.add('is-in');
      });
      return;
    }
    if (!riseObserver) {
      riseObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          e.target.classList.add('is-in');
          riseObserver.unobserve(e.target);
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });
    }
    Array.prototype.forEach.call(nodes, function (n) {
      n.setAttribute('data-b2b-seen', '');
      riseObserver.observe(n);
    });
  }

  /* ------------------------------------------------------------------- hero */
  function initHero(root) {
    var nodes = root.querySelectorAll('[data-b2b-hero]:not([data-b2b-ready])');
    Array.prototype.forEach.call(nodes, function (hero) {
      hero.setAttribute('data-b2b-ready', '');
      // el producto entra con escala y luz apenas se pinta la página
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () { hero.classList.add('is-in'); });
      });
    });
  }

  /* --------------------------------------------- ensamblado: scrub por scroll */
  function initAssembly(root) {
    var nodes = root.querySelectorAll('[data-b2b-assembly]:not([data-b2b-ready])');

    Array.prototype.forEach.call(nodes, function (section) {
      section.setAttribute('data-b2b-ready', '');

      var canvas = section.querySelector('[data-b2b-sprite]');
      var video = section.querySelector('[data-b2b-scrub]');
      var rail = section.querySelector('[data-b2b-rail]');
      var steps = [].slice.call(section.querySelectorAll('[data-b2b-step]'));
      var ultimoP = 0;

      function progreso() {
        var rect = section.getBoundingClientRect();
        var recorrido = section.offsetHeight - window.innerHeight;
        return recorrido > 0 ? clamp01(-rect.top / recorrido) : 0;
      }

      function pintarPasos(p) {
        if (!steps.length) return;
        var i = Math.min(steps.length - 1, Math.floor(p * steps.length));
        steps.forEach(function (s, n) { s.classList.toggle('is-on', n === i); });
      }

      /* --- modo sprite: una imagen con todos los cuadros, dibujada en canvas.
         Es determinístico y no depende de políticas de autoplay ni de seek. --- */
      var dibujar = null;
      if (canvas) {
        var ctx = canvas.getContext('2d');
        var cols = parseInt(canvas.getAttribute('data-cols'), 10) || 1;
        var rows = parseInt(canvas.getAttribute('data-rows'), 10) || 1;
        var total = parseInt(canvas.getAttribute('data-frames'), 10) || cols * rows;
        var hoja = new Image();
        var listo = false;
        var cw = 0;
        var ch = 0;

        hoja.decoding = 'async';
        hoja.addEventListener('load', function () {
          cw = hoja.naturalWidth / cols;
          ch = hoja.naturalHeight / rows;
          canvas.width = cw;
          canvas.height = ch;
          listo = true;
          dibujar(ultimoP);
        });
        hoja.src = canvas.getAttribute('data-src');

        dibujar = function (p) {
          if (!listo) return;
          var i = Math.round(p * (total - 1));
          if (i < 0) i = 0;
          if (i > total - 1) i = total - 1;
          ctx.drawImage(hoja, (i % cols) * cw, Math.floor(i / cols) * ch, cw, ch, 0, 0, cw, ch);
        };
      } else if (video) {
        /* --- respaldo: scrub del video (sólo confiable en desktop) --- */
        var dur = 0;
        video.addEventListener('loadedmetadata', function () { dur = video.duration || 0; });
        var destrabar = function () {
          var pr = video.play();
          if (pr && pr.then) pr.then(function () { video.pause(); }).catch(function () {});
          else video.pause();
        };
        if (video.readyState >= 1) { dur = video.duration || 0; destrabar(); }
        else video.addEventListener('loadeddata', destrabar, { once: true });

        dibujar = function (p) {
          if (!dur) return;
          try { video.currentTime = dur * p; } catch (e) { /* todavía no seekable */ }
        };
      }

      function actualizar() {
        var p = isReduced() ? 1 : progreso();
        ultimoP = p;
        if (rail) rail.style.width = (p * 100).toFixed(2) + '%';
        if (isReduced()) {
          steps.forEach(function (s) { s.classList.add('is-on'); });
        } else {
          pintarPasos(p);
        }
        if (dibujar) dibujar(p);
      }

      var pendiente = false;
      function alScrollear() {
        if (pendiente) return;
        pendiente = true;
        window.requestAnimationFrame(function () { actualizar(); pendiente = false; });
      }

      var escuchando = false;
      function escuchar(on) {
        if (on === escuchando) return;
        escuchando = on;
        if (on) {
          window.addEventListener('scroll', alScrollear, { passive: true });
          window.addEventListener('resize', alScrollear);
        } else {
          window.removeEventListener('scroll', alScrollear);
          window.removeEventListener('resize', alScrollear);
        }
      }

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          escuchar(entries[0].isIntersecting);
          if (entries[0].isIntersecting) actualizar();
        }, { rootMargin: '160% 0px' }).observe(section);
      } else {
        escuchar(true);
      }

      reduced.addEventListener('change', actualizar);
      actualizar();
    });
  }

  /* ------------------------------------------------- videos del laboratorio */
  function initLabVideos(root) {
    var nodes = root.querySelectorAll('[data-b2b-lab-video]:not([data-b2b-ready])');

    Array.prototype.forEach.call(nodes, function (card) {
      card.setAttribute('data-b2b-ready', '');
      var video = card.querySelector('video');
      var toggle = card.querySelector('[data-b2b-lab-toggle]');
      if (!video) return;

      var autoplay = card.getAttribute('data-b2b-autoplay') === 'true';
      var userPaused = false;

      function loadSources() {
        if (video.getAttribute('data-b2b-sources') !== 'pending') return;
        [].slice.call(video.querySelectorAll('source[data-src]')).forEach(function (s) {
          s.src = s.getAttribute('data-src');
          s.removeAttribute('data-src');
        });
        video.setAttribute('data-b2b-sources', 'loaded');
        video.load();
      }
      function play() {
        loadSources();
        // muted debe estar en la propiedad, no sólo en el atributo: sin eso
        // Safari en iOS rechaza el play() automático.
        video.muted = true;
        video.playsInline = true;
        var p = video.play();
        if (p && p.catch) p.catch(function () {});
        card.classList.add('is-playing');
        if (toggle) toggle.setAttribute('aria-label', toggle.getAttribute('data-label-pause'));
      }
      function pause() {
        video.pause();
        card.classList.remove('is-playing');
        if (toggle) toggle.setAttribute('aria-label', toggle.getAttribute('data-label-play'));
      }

      if (toggle) {
        toggle.addEventListener('click', function () {
          if (video.paused) { userPaused = false; play(); } else { userPaused = true; pause(); }
        });
      }

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) {
              loadSources();
              if (autoplay && !userPaused && !isReduced()) play();
            } else if (!video.paused) {
              pause();
            }
          });
        }, { threshold: 0.25, rootMargin: '25% 0px' }).observe(card);
      } else {
        loadSources();
      }
    });
  }

  /* -------------------------------------------------------------------- faq */
  function initFaq(root) {
    var nodes = root.querySelectorAll('[data-b2b-faq]:not([data-b2b-ready])');

    Array.prototype.forEach.call(nodes, function (list) {
      list.setAttribute('data-b2b-ready', '');
      var single = list.getAttribute('data-b2b-single') === 'true';
      var buttons = [].slice.call(list.querySelectorAll('[data-b2b-faq-q]'));

      buttons.forEach(function (btn, index) {
        var row = btn.closest('.b2b-faq__row');

        btn.addEventListener('click', function () {
          var open = btn.getAttribute('aria-expanded') === 'true';
          if (single && !open) {
            buttons.forEach(function (other) {
              if (other === btn) return;
              other.setAttribute('aria-expanded', 'false');
              other.closest('.b2b-faq__row').classList.remove('is-open');
            });
          }
          btn.setAttribute('aria-expanded', open ? 'false' : 'true');
          row.classList.toggle('is-open', !open);
        });

        // flechas y Home/End entre preguntas, como pide el patrón de acordeón
        btn.addEventListener('keydown', function (event) {
          var next = null;
          if (event.key === 'ArrowDown') next = buttons[(index + 1) % buttons.length];
          else if (event.key === 'ArrowUp') next = buttons[(index - 1 + buttons.length) % buttons.length];
          else if (event.key === 'Home') next = buttons[0];
          else if (event.key === 'End') next = buttons[buttons.length - 1];
          if (!next) return;
          event.preventDefault();
          next.focus();
        });
      });
    });
  }

  /* ------------------------------------------------------------------- boot */
  function init(root) {
    var scope = root || document;
    initRise(scope);
    initHero(scope);
    initAssembly(scope);
    initLabVideos(scope);
    initFaq(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:select', function (e) { init(e.target); });
})();
